<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchTitle"></breadcrumb-search>
      <div style="display: flex; padding-bottom: 24px">
        <div v-for="(item, index) in records" :key="index" class="record-item">
          <div>
            <img style="width: 56px; height: 56px" :src="item.img" />
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="price">
              <span style="font-size: 16px">￥</span>{{ item.price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" :model="searchForm" ref="search" size="small">
          <el-form-item label="下单用户" prop="username">
            <el-input style="width: 232px" v-model="searchForm.username" placeholder="请输入下单用户" clearable></el-input>
          </el-form-item>
          <el-form-item label="佣金归属人信息" prop="commissionName">
            <el-input style="width: 232px" v-model="searchForm.commissionName" placeholder="佣金归属人信息"></el-input>
          </el-form-item>
          <el-form-item label="订单编号" prop="orderNo">
            <el-input style="width: 232px" v-model="searchForm.orderNo" placeholder="请输入订单编号"></el-input>
          </el-form-item>
          <el-form-item label="订单日期" prop="orderTimeStart">
            <el-date-picker style="width: 232px" v-model="orderTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到账日期" prop="settleTimeStart">
            <el-date-picker style="width: 232px" v-model="settleTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="佣金类型" prop="commissionType">
            <el-select style="width: 232px" v-model="searchForm.commissionType" placeholder="请选择佣金类型" filterable
              clearable>
              <el-option label="自返佣金" value="1"></el-option>
              <el-option label="一级佣金" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="settleStatus">
            <el-select style="width: 232px" v-model="searchForm.settleStatus" placeholder="请选择状态" filterable clearable>
              <el-option label="未到账" value="1"></el-option>
              <el-option label="已到账" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" icon="el-icon-upload2" :loading="exporting" @click="exportFn">导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="recordList" pagination :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage" :page-size="page.pageSize" @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      dataList: {
        list: [
          { title: '财务管理', path: '', type: '0' },
          { title: '佣金记录表', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '数据筛选', path: '', type: '0' }
        ]
      },
      records: [
        {
          img: require('../../../assets/icon_daijiesuan.png'),
          title: '待结算佣金',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_shangpin.png'),
          title: '商品佣金总数',
          price: '10000'
        },
      ],
      searchTitle: {
        list: [
          { title: '佣金记录', path: '', type: '0' }
        ]
      },
      searchForm: {
        username: '', // 	否 	string 	下单用户
        commissionName: '', // 	否 	string 	推荐人信息
        orderNo: '', // 	否 	int 	订单编号
        orderTimeStart: '', // 	订单时间-开始
        orderTimeEnd: '', // 	订单时间-结束
        settleTimeStart: '', // 	到账时间-开始
        settleTimeEnd: '', // 	到账时间-结束
        commissionType: null, // 	佣金类型1自返佣金2一级佣金
        settleStatus: null //1未到账2已到账
      },
      orderTime: [],//订单时间
      settleTime: [],//到账时间
      value1: [],
      brandList: [],
      columns: [
        // { type: 'selection', minWidth: '80', fixed: 'left' },
        {
          label: '下单用户', prop: 'orderUsername', width: '120',
          render: (h, scope) => {
            return (
              <div>
                <div>{scope.row.orderUsername}</div>
                <div>{scope.row.orderUserPhone}</div>
              </div>

            )
          }
        },
        { label: '订单编号', prop: 'orderNo', width: '170' },
        {
          label: '订单商品',
          minWidth: '200',
          render: (h, scope) => {
            if (!scope.row.goodsList) return
            return (
              <div>
                {
                  scope.row.goodsList.map(item => {
                    return (
                      <p>{item.name + '*' + item.quantity}</p>
                    )
                  })
                }
              </div>
            )
          }
        },
        { label: '订单日期', prop: 'orderTime', minWidth: '120' },
        { label: '订单金额', prop: 'receivableAmount', width: '100' },
        { label: '订单佣金', prop: 'commission', width: '100' },
        {
          label: '佣金归属人', prop: 'commissionUserName', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <div>{scope.row.commissionUserName}</div>
                <div>{scope.row.commissionUserPhone}</div>
              </div>

            )
          }
        },
        { label: '佣金类型', prop: 'commissionTypeLabel', minWidth: '100' },
        {
          label: '状态', prop: 'settleStatusLabel', width: '100',
          render: (h, scope) => {
            let dom = [
              <div style="display:flex;align-items:center;justify-content:center;">
                <div style="width:10px;height:10px;background:#13CE4B;border-radius:50%;margin-right:4px;"></div>
                <p>{scope.row.settleStatusLabel}</p>
              </div>
            ]
            if (scope.row.settleStatusLabel.indexOf('未到账') > -1) {
              dom = [
                <div style="display:flex;align-items:center;justify-content:center;">
                  <div style="width:10px;height:10px;background:#FF9226;border-radius:50%;margin-right:4px;"></div>
                  <p>{scope.row.settleStatusLabel}</p>
                </div>
              ]

            }
            return dom
          }
        },
        { label: '到账时间', prop: 'settleTime', minWidth: '120' },
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      recordList: [],
      statistics: {},
      exporting: false
    }
  },
  created() {
    this.getCommissionRecordPageList()
    this.getCommissionStatistics()
  },
  methods: {
    exportFn() {
      this.exporting = true;
      if (this.orderTime) {
        this.searchForm.orderTimeStart = this.orderTime[0];
        this.searchForm.orderTimeEnd = this.orderTime[1];
      } else {
        this.searchForm.orderTimeStart = '';
        this.searchForm.orderTimeEnd = '';
      }
      if (this.settleTime) {
        this.searchForm.settleTimeStart = this.settleTime[0];
        this.searchForm.settleTimeEnd = this.settleTime[1];
      } else {
        this.searchForm.settleTimeStart = '';
        this.searchForm.settleTimeEnd = '';
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/users/getCommissionRecordExport', this.searchForm)
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code == 0) {
            this.downloadlink(res.data)
          }
        })
    },
    getCommissionStatistics() {
      this.axios.get('/users/getCommissionStatistics')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.records[0].price = res.data.awaitCommission;
            this.records[1].price = res.data.totalCommission
          }
        })
    },
    fetchData(type) {
      this.page.pageNo = 1;
      if (type == 'search') {

      } else {
        this.settleTime = []
        this.orderTime = []
        this.$refs['search'].resetFields()
      }
      this.getCommissionRecordPageList()
    },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getCommissionRecordPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getCommissionRecordPageList()
    },
    getCommissionRecordPageList() {
      if (this.orderTime) {
        this.searchForm.orderTimeStart = this.orderTime[0];
        this.searchForm.orderTimeEnd = this.orderTime[1];
      } else {
        this.searchForm.orderTimeStart = '';
        this.searchForm.orderTimeEnd = '';
      }
      if (this.settleTime) {
        this.searchForm.settleTimeStart = this.settleTime[0];
        this.searchForm.settleTimeEnd = this.settleTime[1];
      } else {
        this.searchForm.settleTimeStart = '';
        this.searchForm.settleTimeEnd = '';
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/users/getCommissionRecordPageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.page.totalNum = res.data.totalNum;
            this.recordList = res.data.list;
          }
        })
    },
    todetail() {
      this.$router.push({
        name: 'userDetail',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="scss">
.record-item {
  display: flex;
  width: 313px;
  height: 88px;
  background: #ffffff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 6px;
  margin-right: 18px;

  img {
    padding: 16px 14px;
  }

  .right {
    margin-top: 16px;

    .title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #303033;
    }

    .price {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 31px;
      color: #303033;
      margin-top: 8px;
    }
  }
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

/deep/ .el-table {
  color: #303033
}
</style>

